import { render } from "./JsonTagsField.vue?vue&type=template&id=6ffb779a"
import script from "./JsonTagsField.vue?vue&type=script&lang=js"
export * from "./JsonTagsField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"JsonTagsField.vue"]])

export default __exports__